export const INVENTORY_PATH = '/inventory';
export const EXCEPTIONS_PATH = '/inventory/exceptions';

//An item's detail opens over the list it was clicked from, so closing it returns to that list with its search and page
export function itemPath(listPath, itemId) {
  return `${listPath}/items/${itemId}`;
}
